<div class="app fx-column">
    <!-- Top bar -->
    <div class="topbar" *ngIf="showLayout">
        <ce-topbar [pageId]="pageId$ | async"></ce-topbar>
        <div class="global-loading">
            <mat-progress-bar [class.hidden]="!showGlobalLoading" mode="indeterminate"></mat-progress-bar>
        </div>
    </div>

    <div class="app-content fx-row fx-flex">
        <!-- Side navigation -->
        <div class="sidenav" *ngIf="showLayout">
            <ce-sidenav [mode]="(isMobile$ | async) ? 'hidden' : 'collapsed'"></ce-sidenav>
        </div>

        <!-- Page content -->
        <div class="page fx-flex" [ngClass]="pageId$ | async">
            <ng-content></ng-content>
        </div>
    </div>
</div>
